export default {
  championship: {},
};
